import React, { useEffect } from 'react';
import { H4 } from '@amzn/stencil-react-components/text';
import { Spacer } from '@amzn/stencil-react-components/layout';
import { FormattedMessage } from 'react-intl';
import LeaderLevelFilter from './segment-filter/LeaderLevelFilter';
import CountryFilter from './segment-filter/CountryFilter';
import ManagerFilter from './segment-filter/ManagerFilter';
import EmployeeJobLevelFilter from './segment-filter/EmployeeJobLevelFilter';
import HireDateFilter from './segment-filter/HireDateFilter';
import MetricFilter from './segment-filter/MetricFilter';
import { useDispatch } from 'react-redux';
import { resetRuleFilters } from '../../actions/ruleFiltersActions';

const RuleFilters = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetRuleFilters());
    };
  }, []);

  return (
    <React.Fragment>
      <H4>
        <FormattedMessage id="app.ruleFilter.label.ruleFilters" defaultMessage="Rule Filters" />
      </H4>
      <Spacer height={32} />
      <LeaderLevelFilter />
      <Spacer height={32} />
      <CountryFilter />
      <Spacer height={32} />
      <ManagerFilter />
      <Spacer height={32} />
      <EmployeeJobLevelFilter />
      <Spacer height={32} />
      <HireDateFilter />
      <Spacer height={32} />
      <MetricFilter />
    </React.Fragment>
  );
};

export default RuleFilters;
